export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const ENABLE_OFFLINE_POS = process.env.REACT_APP_ENABLE_OFFLINE_POS !== "false";
export const APP_NAME = "Webbie";
export const APP_LOGO = "../../../assets/images/logo.png";
export const BANNER_IMG = "assets/images/banner.png";
export const GLOBAL_CURRENCY = {
    symbol: "R",
    code: "ZAR",
    name: "South African Rand"
}
export const GLOBAL_COUNTRY_CODE = {
    "flag": "https://geo5.net/imagens/Bandeira-da-Africa-do-Sul.png",
    "name": "South Africa",
    "dial_code": "27",
    "code": "SA"
}
export const BULK_UPLOAD_CATEGORIES_SAMPLE_URL= "https://webbie.s3.af-south-1.amazonaws.com/Sample_files_webbieshop/Sample_Categories.xlsx"
export const BULK_UPLOAD_PRODUCTS_SAMPLE_URL="https://webbie.s3.af-south-1.amazonaws.com/Sample_files_webbieshop/Sample_products%20bulk%20(2).xlsx"
// export const BULK_UPLOAD_PRODUCTS_SAMPLE_URL="https://docketell-file.s3.amazonaws.com/Sample_files_webbieshop/Sample_products.xlsx"

export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API
export const TERMS_OF_SERVICE = 'https://www.venturestudiocms.com/api/general-pages/97?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'
export const PRIVACY_POLICY = 'https://www.venturestudiocms.com/api/general-pages/98?populate=hero_section.media, description.paragraphs.media,other_content_blocks.media,quick_links.cards.media'

